<template>
  <div>
    <!-- ランキング -->
    <section class="section">
      <div class="title-area">
        <h2 class="sub-title">
          {{ Ranking.all[lang] }}
        </h2>
        <!-- 更新時間 -->
        <div
          class="update-time"
          v-if="
            !isLoadingRanking &&
            !isNotFound &&
            !isServerError &&
            dataRanking.event_date_at[lang]
          "
        >
          {{ dataRanking.event_date_at[lang] }}
        </div>
      </div>
      <!-- ランキングタブ -->
      <ul class="ranking-tab-list">
        <li
          v-for="(tab, index) in tabNameList"
          :key="index"
          class="ranking-tab-list__item"
          :class="{ 'tab-active': isTabActive === index }"
          @click="onTabClick(index)"
          >{{ tab.text[lang] }}</li
        >
      </ul>
      <!-- 対象外 または ランキングデータが空 の時はランキングを表示しない。 -->
      <div v-if="!isExcludedRanking && !isEmpty">
        <!-- ページング  -->
        <v-pagination
          v-if="!isLoadingRanking && !isNotFound && !isServerError"
          v-model="$page.current"
          v-bind:length="$page.total"
          v-bind:total-visible="$page.visible"
          color="#0093e6"
          class="rank-pagination"
        ></v-pagination>
        <Status
          :is-loading-ranking="isLoadingRanking"
          :is-not-found="isNotFound"
          :is-server-error="isServerError"
          :is-initial-ranking-data="isInitialRankingData"
          :event-status="eventStatus"
          :count-total-runner="0"
          @initial-ranking="initialRanking"
        ></Status>
        <!-- ランキングリスト（1位~100位） -->
        <TeamRankingList
          v-if="!isLoadingRanking && !isNotFound && !isServerError"
          :lang="lang"
          :lang-path="langPath"
          :ranking="TeamRanking"
          :data-event-ranking="dataEventRanking"
          :data-event-summary="dataEventSummary"
          :data-ranking="dataRanking"
          :event-status="eventStatus"
          :is-foreign-country="isForeignCountry"
          :nass-event-id="nassEventId"
        ></TeamRankingList>
        <!-- ページング  -->
        <v-pagination
          v-if="!isLoadingRanking && !isNotFound && !isServerError"
          v-model="$page.current"
          v-bind:length="$page.total"
          v-bind:total-visible="$page.visible"
          color="#0093e6"
          class="rank-pagination"
        ></v-pagination>
      </div>
      <div v-if="isExcludedRanking" class="hidden-ranking-message">
        {{ Ranking.excludedRanking1[lang] }}
        {{ tabNameList[isTabActive].text[lang] }}
        {{ Ranking.excludedRanking2[lang] }}
      </div>
      <div v-else-if="isEmpty" class="hidden-ranking-message">
        {{ Ranking.emptyRanking[lang] }}
      </div>

      <hr class="width-line" />

      <!-- 個人記録検索  -->
      <PersonalDataSearch></PersonalDataSearch>
    </section>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../../api/RepositoryFactory";
import Ranking from "../../../../assets/constants/ranking/ranking.json";
import Loading from "../../Loading";
import BadRequest from "../../../common/status/BadRequest";
import InternalServerError from "../../../common/status/InternalServerError";
import Status from "../../ranking/Status";
import TeamRanking from "../../../../assets/constants/company/ranking/teamRanking.json";
import TeamRankingList from "./TeamRankingList";
import PersonalDataSearch from "./PersonalDataSearch";

export default {
  props: {
    dataEventRanking: Object,
    dataEventSummary: Object,
    isForeignCountry: Boolean,
  },
  data() {
    return {
      isLoadingRanking: true,
      isBadRequest: false,
      isNotFound: false,
      isServerError: false,
      isInitialRankingData: false,
      isEmpty: false,
      dataRanking: null,
      nassEventId: "",
      eventStatus: "",
      countTotalTeam: 0,
      teamRanking: {},
      tabNameList: [],
      isTabActive: 0, // 初期表示するタブのインデックス
      isExcludedRanking: true, // 選択中のランキングが表示可能か
    };
  },
  async created() {
    // イベントID取得
    this.nassEventId = sessionStorage.getItem("nassEventId");
    // タブ
    const hasRegulatedDistance =
      this.dataEventSummary.summary.has_regulated_distance; // 規定距離の有無を取得
    this.teamRanking = hasRegulatedDistance
      ? TeamRanking.fixed_distance
      : TeamRanking.unlimited_distance;
    this.tabNameList = this.teamRanking.tab_list;
    this.isTabActive = this.teamRanking.initial_active_index;
    // ランキング取得
    await this.initialRanking();
  },
  methods: {
    /**
     * 初回検索
     */
    initialRanking: async function () {
      // 条件初期化
      this.initialConditions();

      // 通信
      await this.fetchRanking(false);

      // 「〇〇人見つかりました」はinitialの時は表示しない
      this.isInitialRankingData = false;
    },

    /**
     * コンポーネントの状態とデータの初期化
     */
    initialConditions: function () {
      this.isLoadingRanking = true;
      this.isNotFound = false;
      this.isServerError = false;
      this.dataRanking = null;
      this.countTotalTeam = 0;
      this.isExcludedRanking = false;
      this.isEmpty = false;
    },

    /**
     * タブ押下時の処理
     */
    onTabClick: async function (tabNumber) {
      this.isTabActive = tabNumber;
      // 対象外のランキングか
      if (this.tabNameList[this.isTabActive].is_excluded) {
        this.isExcludedRanking = true;
        return;
      }
      this.initialConditions();
      await this.fetchRanking(false);
    },

    /**
     * 通信部分共通
     */
    fetchRanking: async function (isOffsetInitial) {
      const param = {
        nass_event: this.nassEventId,
        sort: this.tabNameList[this.isTabActive].sort,
        offset: isOffsetInitial ? 0 : (this.$route.query.page - 1) * 100,
        limit: 100,
      };

      try {
        const RankingRepository = RepositoryFactory.get("ranking");
        const response = await RankingRepository.getTeamRanking(param);
        this.dataRanking = response.data;

        // 総件数（paging用と表示用）
        this.$page.rows = response.data.team_ranking.meta_data.total_count;
        this.countTotalTeam = response.data.team_ranking.meta_data.total_count;

        // イベントステータス（'0'か'100'）
        this.eventStatus = response.data.team_ranking.meta_data.status;

        // 「〇〇人見つかりました」はinitialの時は表示しない
        this.isInitialRankingData = true;

        // ランナー0の時はランキングを表示しない。
        if (response.data.team_ranking.company_contents.length === 0) {
          this.isEmpty = true;
        }

        // ページ数をセット
        this.$page.current = isOffsetInitial ? 1 : this.$route.query.page;
      } catch (e) {
        if (e.response.status === 404) {
          this.$page.rows = 0;
          this.isNotFound = true;
        } else {
          this.isServerError = true;
        }
      } finally {
        this.isLoadingRanking = false;
      }
    },
  },
  computed: {
    Ranking: function () {
      return Ranking;
    },
    TeamRanking: function () {
      return TeamRanking;
    },
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  watch: {
    "$page.current": function (newNumber) {
      this.$router.push(
        {
          name: this.name,
          query: {
            event: this.$route.query.event,
            page: newNumber,
          },
        },
        () => {
          this.fetchRanking(false);
        }
      );
    },
  },
  components: {
    Loading,
    BadRequest,
    InternalServerError,
    Status,
    TeamRankingList,
    PersonalDataSearch,
  },
  name: "TeamRankingContents",
};
</script>

<style scoped lang="scss">
.section {
  margin: 60px 0 0 0;
}

.title-area {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .sub-title {
    font-size: 32px;
    font-weight: 900;
  }
  .update-time {
    font-size: 16px;
    font-weight: bold;
  }
}

.ranking-tab-list {
  display: flex;
  margin: 70px 0 0 0;
  padding: 0 5px;
  border-bottom: solid 1px #000;
  &__item {
    flex: 1;
    padding: 18px;
    font-size: 24px;
    font-weight: bold;
    color: #333;
    background-color: #eee;
    cursor: pointer;
    text-align: center;
    margin: 0 15px;
  }
  .tab-active {
    margin: 0 15px -1px;
    border-top: solid 1px #000;
    border-right: solid 1px #000;
    border-left: solid 1px #000;
    background-color: #fff;
  }
}

.rank-pagination {
  margin: 80px 0 0 0;
}

.hidden-ranking-message {
  text-align: center;
  padding: 100px 0;
}

.width-line {
  margin: 60px 0 0 0;
  width: 100%;
  border-top: solid 1px #000;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/company/ranking/TeamRankingContents.vue